const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col items-center justify-center space-y-2">
          <p className="text-sm text-slate-200">
            © {new Date().getFullYear()} Medical Report Extractor
          </p>
          <div className="text-xs text-slate-400">
            Secure Medical Data Analysis
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
